<template>
  <div class="pagination-wrapper">
    <nav class="pagination" role="navigation" aria-label="pagination">
      <a :disabled="!previousPage" class="button is-small pagination-previous" @click="changePage(previousPage)">Previous</a>
      <a :disabled="!nextPage" class="button is-small pagination-next" @click="changePage(nextPage)">Next</a>
      <div class="pagination-list">Page {{ currentPage }} of {{ lastPage }}</div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: ['totalItems', 'currentPage', 'itemsPerPage'],
  computed: {
    lastPage () {
      var totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
      return totalPages > 0 ? totalPages : 1
    },
    previousPage () {
      if (this.currentPage === 1) {
        return null
      }
      return this.currentPage - 1
    },
    nextPage () {
      if (this.currentPage === this.lastPage) {
        return null
      }
      return this.currentPage + 1
    }
  },
  methods: {
    changePage (page) {
      if (!page) return
      this.$emit('update:currentPage', page)
    }
  },
  watch: {
    currentPage () {
      this.$emit('change')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue